/**
*
* RedJoinConversation
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import defaultTextValues from './defaultTextValues';

class RedJoinConversation extends React.PureComponent {

  render() {
    const {
      commonData,
      openEditor,
      commonProps,
      defaultValues
    } = this.props;


    const {
      twitterAccount,
      facebookAccount,
      linkedinAccount,
      instagramAccount,
      slackAccount,
    } = defaultValues;

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'sectionTitleWrapper'}
            editorData={
              {
                editorType: 'sectionTitleWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'sectionTitle'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'sectionTitle',
                  ...commonData
                }
              }
            />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'socialIconsContent'}
                editorData={
                  {
                    editorType: 'socialIconsContent',
                    ...commonData
                  }
                }
              >
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'linkedinIcon'}
                  
                  target={'_blank'}
                  href={linkedinAccount}
                  editorData={
                    {
                      editorType: 'linkedinIcon',
                      ...commonData
                    }
                  }
                />
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'facebookIcon'}
                  
                  target={'_blank'}
                  href={facebookAccount}
                  editorData={
                    {
                      editorType: 'facebookIcon',
                      ...commonData
                    }
                  }
                />

                <Wrapper
                  {...commonProps}
                  typeOfStyle={'instagramIcon'}
                  
                  target={'_blank'}
                  href={instagramAccount}
                  editorData={
                    {
                      editorType: 'instagramIcon',
                      ...commonData
                    }
                  }
                />

                <Wrapper
                  {...commonProps}
                  typeOfStyle={'twitterIcon'}
                  
                  target={'_blank'}
                  href={twitterAccount}
                  editorData={
                    {
                      editorType: 'twitterIcon',
                      ...commonData
                    }
                  }
                />
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'slackIcon'}
                  
                  href={slackAccount}
                  editorData={
                    {
                      editorType: 'slackIcon',
                      ...commonData
                    }
                  }
                />    
              </Wrapper>
          </Wrapper>
          <Wrapper
              {...commonProps}
              
              typeOfStyle={'paragraph'}
              type={'text'}
              defaultValues={defaultTextValues}
              editorData={
                {
                  editorType: 'paragraph',
                  ...commonData
                }
              }
            />
        </Wrapper>
      </Wrapper>
    );


  }
}

RedJoinConversation.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  speakers: PropTypes.array,
  setShowPopup: PropTypes.func,
  defaultValues: PropTypes.object,
  thisSpeaker: PropTypes.object,
  companies: PropTypes.array,
};

export default RedJoinConversation;
